import { FormField, Heading, ReadOnlyField } from '@msaf/core-react'
import { TOOLTIP } from '../../../../constants/tooltips'
import { InputWidth } from '../../../../types/aoraki/input-width-types'
import { WellHeadSecurityFieldsView } from '../../../../types/form-types'

export interface WellheadSecuritySubFormProps {
  isLoading: boolean
  fields: Partial<WellHeadSecurityFieldsView>
}

export default function WellheadSecurityViewQuality({ isLoading, fields }: WellheadSecuritySubFormProps) {
  return (
    <>
      <Heading isSkeleton={isLoading} level={3}>
        Overall quality
      </Heading>
      <FormField
        toolTipMessage={TOOLTIP.inspectedBy}
        isSkeleton={isLoading}
        labelId='inspectionBy'
        label='Inspected by'
      >
        <ReadOnlyField isSkeleton={isLoading} labelledBy='inspectionBy' value={fields?.inspectedBy ?? ''} />
      </FormField>

      <FormField
        toolTipMessage={TOOLTIP.inspectionDate}
        isSkeleton={isLoading}
        labelId='inspectionDate'
        label='Inspection date'
      >
        <ReadOnlyField
          fieldSize={InputWidth.large}
          isSkeleton={isLoading}
          labelledBy='inspectionDate'
          value={fields?.inspectionDate ?? ''}
        />
      </FormField>

      <FormField isSkeleton={isLoading} labelId='wellheadSecurityRating' label='Overall rating'>
        <ReadOnlyField
          isSkeleton={isLoading}
          labelledBy='wellheadSecurityRating'
          value={fields?.overallSecurityRating ?? ''}
        />
      </FormField>

      <FormField isSkeleton={isLoading} labelId='comment' label='Comment'>
        <ReadOnlyField isSkeleton={isLoading} labelledBy='comment' value={fields?.overallSecurityComment ?? ''} />
      </FormField>
    </>
  )
}
